import styles from './Percentage.module.css';

export const PercentageBar = ({ width, resut }) => {
  return (
    <div className={styles.wrapper}>
      <div
        className={styles.percentageBar}
        style={{ maxWidth: `${resut ? width : 0}%` }}
      />
    </div>
  );
};
